import { render, staticRenderFns } from "./publish-tooltip-button.vue?vue&type=template&id=0cdd6b14"
import script from "./publish-tooltip-button.vue?vue&type=script&lang=js"
export * from "./publish-tooltip-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports